import { StateCreator } from 'zustand';
import { LineItemFulfillmentDetailsInput } from '@/gql';
import { CheckoutPricingInformation } from '@/types/checkout';
import { LineItemData } from '@/components/CheckoutSummaryLineItem';

export interface PricingSlice {
  lineItems?: LineItemFulfillmentDetailsInput[];
  setLineItems: (lineItems: LineItemFulfillmentDetailsInput[]) => void;
  pricingInfo?: CheckoutPricingInformation;
  setPricingInfo: (pricingInfo: CheckoutPricingInformation) => void;
  summaryLineItems?: LineItemData[];
  setSummaryLineItems: (summaryLineItems: LineItemData[]) => void;
  clearPricingInfo: () => void;
}

export const createPricingSlice: StateCreator<PricingSlice, [], [], PricingSlice> = (set) => ({
  lineItems: undefined,
  setLineItems: (lineItems) => set({ lineItems }),
  pricingInfo: undefined,
  setPricingInfo: (pricingInfo) => set({ pricingInfo }),
  summaryLineItems: undefined,
  setSummaryLineItems: (summaryLineItems) => set({ summaryLineItems }),
  clearPricingInfo: () => set({ pricingInfo: undefined }),
});
